RivalIQ.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    // browser related utilities
    const browser = utils.browser = {};

    function getUserAgent() {
        return _.get(window, ['navigator', 'userAgent']);
    }

    browser.isEdge = function () {
        const userAgent = getUserAgent();
        return (userAgent.indexOf('Edge/') !== -1);
    };

    browser.isMobile = function () {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768;
    };

    browser.isTablet = function () {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 1024;
    };

    browser.isFirefox = function () {
        const userAgent = getUserAgent();
        return (userAgent.indexOf('Firefox/') !== -1);
    };

    browser.isWindows = function () {
        const userAgent = getUserAgent();
        return (userAgent.indexOf('Windows') !== -1);
    };

});
